import React, { Component } from 'react';
import FormControl from 'bee-form-control';
import { NEED_SELECTION_ITEMS } from './constants';
import { isArrowKeyDown, ctrlKeyWithUpDown, isEnterKeyDown, toast, getMultiLang } from '@platform/api';
import WithKeyboardChange from '../WithKeyboardChange';
import { getSysFieldid } from '@platform/api';

const { processCursorPointInSide } = WithKeyboardChange;

require('bee-form-control/build/FormControl.css');
require('bee-icon/build/Icon.css');
require('./index.less');

export default class NCFormControl extends Component {
    constructor(props) {
        super(props);
        this.chineseEntering = false;
        this.state = { json: {} }
    }

    componentWillMount() {
        // 初始化调用getPlatformLang方法获取多语
        let callback = json => {
            this.setState({ json });
        };
        getMultiLang({ moduleId: 'base_text_check', callback }); // moduleId为所需加载json文件夹名称前缀
    }

    componentDidMount() {
        let { maxlength, isCheckChinese, watchPaste = false } = this.props;
        if (this.i && maxlength && isCheckChinese) {
            let inputNode = ReactDOM.findDOMNode(this.i);
            inputNode.addEventListener(
                'compositionstart',
                this.setInputFlag.bind(this, inputNode, true),
                false,
            );
            inputNode.addEventListener(
                'compositionend',
                this.setInputFlag.bind(this, inputNode, false),
                false,
            );
            watchPaste && inputNode.addEventListener(
                'paste',
                event=>this.handlePaste(event),
                false,
            );
        }
    }

    handlePaste = event=>{
        let pasteContent = event.clipboardData.getData('text/plain');
        if (pasteContent.length > 2) {
            var endStr = pasteContent.substr(pasteContent.length - 1, pasteContent.length);
            if (endStr === '\n') {
                pasteContent = pasteContent.substr(0, pasteContent.length - 1);
            }
            if (pasteContent.substr(pasteContent.length - 1, pasteContent.length) === '\r') {
                pasteContent = pasteContent.substr(0, pasteContent.length - 1);
            }
        }
        // 多列取第一列
        let reg = /\t/;
        let text = [];
        if (reg.test(pasteContent)) {
            let rows = pasteContent.split('\r\n') || [];
            rows.forEach(row => {
                let cells = row.split('\t') || [];
                let firstCell = cells[0];
                text.push(firstCell);
            });
        } else {
            text = pasteContent.split('\r\n');
        }
        let result = text.join(',');
        this.setState({ value: result });
        let inputNode = ReactDOM.findDOMNode(this.i);
        inputNode.value = result;
        this.setInputFlag(inputNode, false, event );
        event.preventDefault();
    }

    setInputFlag = (inputNode, flag, e) => {
        //处理中文输入
        this.chineseEntering = flag;
        if (flag === false) {
            let { maxlength, onChange } = this.props;
            let value = inputNode.value;
            if (value) {
                value = this.getCalcText(value, maxlength);
            }
            if (typeof onChange === 'function') {
                inputNode.value = value;
                e.target.value = value;
                console.log("事件对象e", e.target.value)
                onChange(value, e);
            }
        }
    }

    /**
     * @author bbqin
     */
    componentDidUpdate() {
        // TODO  目前逻辑在 setstate后
        // TODO 做一些事件绑定的工作
        // typeof Message ? Message.listen('', this.)
    }

    componentWillUnmount() {
        let { maxlength, isCheckChinese, watchPaste = false } = this.props;
        if (this.i && maxlength && isCheckChinese) {
            let inputNode = ReactDOM.findDOMNode(this.i);
            inputNode.removeEventListener(
                'compositionstart',
                this.setInputFlag.bind(this, inputNode, true),
                false,
            );
            inputNode.removeEventListener(
                'compositionend',
                this.setInputFlag.bind(this, inputNode, false),
                false,
            );
            watchPaste && inputNode.removeEventListener(
                'paste',
                event=>this.handlePaste(event),
                false,
            );
        }
    }

    /**
     * @author bbqin
     */
    handleFocus = (value, e) => {
        const { onFocus, itemtype } = this.props;
        // 公式编辑器的问题  已经放到公式编辑器内部处理了  这里最好少做限制
        onFocus && onFocus(e, value);
        // }
        //this.mouseDown 表示用户用鼠标点击此组件
        this.mouseDown !== true &&
            NEED_SELECTION_ITEMS.includes(itemtype) &&
            this.executeSelection(e);
    };

    executeSelection(e) {
        let length = e.target.value.length;
        e.target.setSelectionRange(0, length);
    }

    handleBlur = (value, e) => {
        //let value = typeof e === 'object' ? e.target.value : e;
        this.mouseDown = false;
        const { onBlur } = this.props;
        onBlur && onBlur(value, e);
    };

    // icon clock event
    closeClick = () => {
        this.i.clearValue();
        if (
            this.i.props.clearSearch &&
            Object.prototype.toString.call(this.i.props.clearSearch).slice(8, 16) === 'Function'
        ) {
            this.i.props.clearSearch();
        }
    };

    searchClick = () => {
        this.i.props.onSearch && this.i.props.onSearch(this.i.props.value);
    };

    mySearch = e => {
        if (e.keyCode === 13) {
            this.i.props.onSearch && this.i.props.onSearch(this.i.props.value);
        }
    };

    onChange = (val, e) => {
        let { onChange, showMax, max, componentClass, maxlength, isCheckChinese } = this.props;

        if (typeof onChange === 'function') {
            if (showMax && typeof max === 'number' && componentClass === 'textarea') {
                if (val.length > max) {
                    return;
                }
            }

            if (isCheckChinese && this.chineseEntering === false && maxlength && val) {
                //其他输入法
                val = this.getCalcText(val, maxlength);
            }
            onChange(val, e);
        }
    }

    getCalcText = (value, maxlength) => {
        maxlength = Number(maxlength);
        let { json } = this.state;
        // 中文下有个特殊字符 数据库里占用的是两个字符
        let valLength = String(value).replace(/\·|[^\x00-\xff]/gi, "--").length;
        if (typeof maxlength === 'number' && valLength > maxlength) {
            let diffLen = valLength - maxlength;
            let sum = 0;
            let charNum = 0;
            for (let i = value.length - 1; i >= 0; i--) {
                if (/\·|[^\x00-\xff]/.test(value[i])) {
                    sum = sum + 2;
                } else {
                    sum++
                }
                charNum++;
                if (sum >= diffLen) {
                    break;
                }
            }
            value = value.substring(0, value.length - charNum);
            if (json) {
                console.log("执行气泡提示")
                toast({
                    mark: 'input-maxlength-tip',
                    color: 'danger',
                    title: json['base-maxlength-check-title'],
                    content: json['base-maxlength-check-content1'] +
                        maxlength +
                        '(' +
                        json['base-maxlength-check-content2'] +
                        Math.floor(maxlength / 2) +
                        json['base-maxlength-check-content3'] +
                        ')',
                });
            }

        }
        return value;
    }

    handleKeyDown = e => {
        let { renderInTable, hotKeyWithArrow, onEnter } = this.props;
        let { target } = e;
        if (isEnterKeyDown(e)) {
            onEnter && onEnter({ e });
        }

        //判断control + 上下键
        if (renderInTable && ctrlKeyWithUpDown(e)) {
            e.keyCode === 38
                ? target.setSelectionRange(-1, 0)
                : target.setSelectionRange(target.value.length, target.value.length);
        }

        //如果按了上下键就直接切换焦点
        if (renderInTable && isArrowKeyDown(e, [38, 40])) {
            hotKeyWithArrow && hotKeyWithArrow({ e });
            return;
        }

        //如果是全选了文字就切换光标
        let selectionValue = document.getSelection().toString();
        if (isArrowKeyDown(e, [37, 39]) && selectionValue === target.value) {
            hotKeyWithArrow && hotKeyWithArrow({ e });
            return;
        }

        //如果是左右键判断是否是选中了所有文字或判断光标在是否在最左侧||最右侧
        if (isArrowKeyDown(e, [37, 39])) {
            processCursorPointInSide(hotKeyWithArrow, e);
            return;
        }

    };

    render() {
        let {
            isViewMode,
            showMax = false,
            max,
            className,
            onBlur,
            showStar,
            value,
            type,
            disabled,
            onEnter,
            fieldid,
            required,
            componentClass,
            onChange,
            maxlength,
            isCheckChinese = false,
            ...others
        } = this.props;
        let flag = false;

        if (!fieldid && type === 'search') {
            fieldid = 'search';
        }

        if (type === 'search') {
            flag = true;
            type = 'text';
        } else if (type === 'password') {
            let { title, ...otherss } = others;
            others = otherss;
        }
        if (value === undefined || value === null) {
            value = '';
        }
        //钉耙底层有做限制
        // if (others.hasOwnProperty('maxlength') && others.maxlength > 0) {
        // 	value = String(value).slice(0, others.maxlength);
        // }

        let count = value.length;

        return isViewMode ? (
            <span>{value}</span>
        ) : (
            <div
                style={{ display: 'inline-block', height: componentClass == 'textarea' && 'auto' }}
                className="u-form-control-wrapper formcontrol-hotkey-wrapper"
                onKeyDown={this.handleKeyDown}
                onMouseDown={() => {
                    this.mouseDown = true;
                }}
            >
                {showStar ? <span className="form-control-required-tag">*</span> : ''}
                <FormControl
                    fieldid={getSysFieldid(fieldid) || null}
                    ref={i => (this.i = i)}
                    className={`nc-input ${className}`}
                    onBlur={this.handleBlur}
                    value={value}
                    type={type}
                    onKeyUp={this.mySearch}
                    disabled={disabled}
                    componentClass={componentClass}
                    {...others}
                    onFocus={this.handleFocus}
                    onChange={this.onChange}
                    maxlength={!isCheckChinese && maxlength}
                />
                {flag ? (
                    <div className="u-form-control-search-text">
                        {' '}
                        {value.length && !disabled ? <i onClick={this.closeClick} className="iconfont icon-qingkong " /> : null}{' '}
                        <i onClick={this.searchClick} className="iconfont icon-sousuo" />
                    </div>
                ) : null}

                {showMax && componentClass == 'textarea' && (
                    <div className="form-control-textarea-countClass">
                        <span>{count || 0}</span>
                        <span>/{max}</span>
                    </div>
                )}
            </div>
        );
    }
}
